import { Component, OnInit, Input, ViewChild, Output, EventEmitter, ElementRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'kt-select-input',
  templateUrl: './select-input.component.html',
  styleUrls: ['./select-input.component.scss']
})
export class SelectInputComponent implements OnInit {
  @ViewChild('select') select: MatSelect;
  @ViewChild('selectFilterInput') selectFilterInput: ElementRef<HTMLInputElement>;
  
  @Input() formGroup: FormGroup;
  @Input() controlName: string;
  @Input() placeholder: string = '';
  @Input() multiple: boolean = false;
  @Input() allOptionEnabled: boolean = false;
  @Input() filterEnabled: boolean = false;
  @Input() clearSelectInputs: BehaviorSubject<boolean> = new BehaviorSubject(false);

  allSelected: boolean = false;
  filteredItemsData:  ISelectItem[] | string[] = [];
  initialItems:  ISelectItem[] | string[] = [];

  selectedItems:  IItemSelecteable[] = [];
  isSelectOpen = false;
  changesCount = 0;

  _items$: BehaviorSubject<ISelectItem[] | string[]>;
  get items(): ISelectItem[] | string[] {
    return this._items$.getValue();
  }
  @Input() set items(value: ISelectItem[] | string[]) {
    this._items$.next(value);
  }

  @Output("toggleSelection") public toggleSelection: EventEmitter<MatOption[]> = new EventEmitter<MatOption[]>();

  constructor() {
    this._items$ = new BehaviorSubject<ISelectItem[] | string[]>([]);
  }

  ngOnInit() {
  }

  ngAfterViewInit(){
    this._items$.subscribe(data => {
      if(this.initialItems.length < 1){
        data?.forEach(x => this.initialItems.push(x));
      }
    });
    this.selectedItems = this.formGroup.get(`${this.controlName}`).value;

    this.clearSelectInputs.subscribe(data =>{
      if(data){
        this.selectedItems = [];
      }
    });
  }

  ngOnChanges(){
    this.changesCount++;
    if(this.controlName === 'formSubTypeId' && this.changesCount <= 2 && this.formGroup.get(`${this.controlName}`).value){
      this._items$.getValue().map(x => {
        if(this.formGroup.get(`${this.controlName}`).value == x.formSubtypeId){
          this.formGroup.get(`${this.controlName}`).setValue(x.id);
        }
      });
    }
  }

  itemIs(type: string, item: ISelectItem | string): boolean {
    return typeof item === type;
  }

  toggleAllSelection() {
    if (this.allSelected) {
      this.select.options.forEach((item: MatOption) => item.select());
    } else {
      this.select.options.forEach((item: MatOption) => item.deselect());
    }
  }
   optionClick(itemId) {
    if(!this.multiple) return;

    let newStatus = true;
    this.select.options.forEach((item: MatOption) => {
      if (!item.selected) {
        newStatus = false;
      }
    });
    this.allSelected = newStatus;

    if(this.filterEnabled){
      if(!this.selectedItems.some(x => x.value == itemId)){
        this.selectedItems.push({value: itemId, selected: true});
      }else{
        if(this.selectedItems.find(x => x.value == itemId).selected === true){
          this.selectedItems.find(x => x.value == itemId).selected = false;
        }else{
          this.selectedItems.find(x => x.value == itemId).selected = true;
        }
      }
      let newData = this.selectedItems.filter(x => x.selected).map(x => {return x.value});
      this.formGroup.get(`${this.controlName}`).setValue(newData);
    }
  }

  onOpenedChange(isOpen: boolean) {
    this.isSelectOpen = isOpen;

    if (!isOpen) {
      this.onSelectBlur();
    }
  }

  onSelectBlur(){
    if(this.filterEnabled){
        this._items$.next(this.initialItems);
      }
  }

  onFilterSelectKeyUp(event) {
    event.stopPropagation();
    if(this.initialItems.length < 1){
      this.initialItems = this.items;
    }

    if(!event.target?.value){
      this._items$.next(this.initialItems);
    }
    let filter = event.target?.value.toLocaleLowerCase();
    if (Array.isArray(this.items) && this.items.length > 0) {
      if (typeof this.items[0] === 'string') {
        this.filteredItemsData = (this.items as string[]).filter(item => 
          item.toLowerCase().includes(filter)
        );
      } else {
        this.filteredItemsData = (this.items as ISelectItem[]).filter(item => 
          item.description.toLowerCase().includes(filter)
        );
      }
      this._items$.next(this.filteredItemsData);
    }
  }

  
  onSelectItem(){
    // setTimeout(() => {
    //   this.selectFilterInput.nativeElement.value = '';
      // this.filteredItemsData = this.items;
    // }, 500);
  }
}

interface ISelectItem {
  id: number,
  description: string
}

interface IItemSelecteable{
  value: number | string;
  selected:  boolean;
}
